import { render, staticRenderFns } from "./DocumentoLicenca.vue?vue&type=template&id=2463771c&scoped=true"
import script from "./DocumentoLicenca.vue?vue&type=script&lang=js"
export * from "./DocumentoLicenca.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2463771c",
  null
  
)

export default component.exports